<template>
<v-card>
  <v-card-title class='subtitle-1 overline' >
    Let's get started
  </v-card-title>
  <v-card-text>
    <p>Adding a new team mate is quick and easy.</p>
    <v-alert type='info' text border="left" >
      Please note that there is an additional charge of R400 per member.
      Your new pricing will apply on your next billing cycle
    </v-alert>
    <v-checkbox
      v-model='accepted'
      label='Accept additional cost'/>
  </v-card-text>
  <v-card-actions>
    <v-spacer/>
    <v-btn @click='$emit("accepted")'
      :disabled='!accepted'
      color="primary" >
      Continue
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  name: 'Terms',
  data () {
    return {
      accepted: false
    }
  }
}
</script>
